WaitlistController.$inject = ["API_URL", "CALENDAR_URL", "$http", "$rootScope", "$location", "$routeParams", "$timeout"];
angular.module('calendarApp').controller('WaitlistController', WaitlistController);

function WaitlistController(API_URL, CALENDAR_URL, $http, $rootScope, $location, $routeParams, $timeout) {
  var wait = this;
  wait.calendarHome = "".concat(CALENDAR_URL, "/").concat(smooth.orgid);
  var slotid = $routeParams.slotid,
      token = $routeParams.token,
      throbber = $rootScope.throbber;

  var init = function init() {
    throbber.show();
    $http.get("".concat(API_URL, "/api/v1/calendar/waitlist/authenticate/").concat(slotid, "/").concat(token)).then(function (reply) {
      var response = reply.data;
      throbber.hide();
      if (response.errortype && response.errortype === 'NO_AVAILABILITY') return wait.noAvailability = true;

      if (!response.success) {
        wait.errorMessage = "Sorry but there was an error with this request: ".concat(response.msg);
        return;
      }

      wait.success = true;
      console.log(response.chosenShift);
      $rootScope.chosenShift = response.chosenShift;
    }).catch(function (err) {
      throbber.showError("Sorry but there was an error with this request: ".concat(err.msg));
    });
  };

  init();

  wait.completeBooking = function () {
    $location.path('/chooseslots');
  };

  wait.cancelWaitlist = function () {
    $http.delete("".concat(API_URL, "/api/v1/calendar/waitlist/").concat(slotid)).then(function (reply) {
      var response = reply.data;
      if (!response.success) return throbber.showError("Sorry but there was an error with this request: ".concat(response.msg));
      throbber.hide();
      wait.removeSuccess = true;
      $timeout(function () {
        $location.path('/');
      }, 3000);
    }).catch(function (err) {
      throbber.showError("Sorry but there was an error with this request: ".concat(err.msg));
    });
  };
}